<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" title="바우처 등록">
        <v-divider class="mt-3 mb-3"></v-divider>
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row align="center">
              <v-col cols="3">
                <span class="ml-1 mb-2">바우처 명</span
                ><span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  v-model="voucherName"
                  placeholder="바우처 명"
                  solo
                  dense
                  required
                  :rules="[(v) => !!v]"
                  maxLength="32"
                  hide-details
                  color="navy"
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <span class="mb-2">바우처 유형</span
                ><span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <v-radio-group
                  v-model="voucherType"
                  row
                  required
                  :rules="[(v) => !!v]"
                >
                  <v-radio label="개수 차감" value="개수 차감"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="3">
                <span>발급 조건</span><span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <span>회원 유형</span>
              </v-col>

              <v-col cols="3"></v-col>
              <v-col cols="9">
                <v-row>
                  <v-checkbox
                    label="전체"
                    v-model="selectAllcustomerType"
                    @change="onSelectAllcustomerType"
                    class="mr-3"
                    dense
                  >
                  </v-checkbox>
                  <v-checkbox
                    v-for="customerType in customerTypeList"
                    v-model="optionList1"
                    :key="customerType.value"
                    :label="customerType.label"
                    :value="customerType.value"
                    @change="selectAllcustomerType = false"
                    class="mr-2"
                    dense
                  >
                  </v-checkbox>
                </v-row>
              </v-col>

              <v-col cols="3"></v-col>
              <v-col cols="9">
                <span>회원 구분</span>
              </v-col>

              <v-col cols="3"></v-col>
              <v-col cols="9">
                <v-row>
                  <v-checkbox
                    label="전체"
                    v-model="selectAllcustomerReg"
                    @change="onSelectAllcustomerReg"
                    class="mr-3"
                    dense
                  >
                  </v-checkbox>
                  <v-checkbox
                    v-for="customerReg in customerRegList"
                    v-model="optionList2"
                    :key="customerReg.value"
                    :label="customerReg.label"
                    :value="customerReg.value"
                    @change="selectAllcustomerReg = false"
                    class="mr-2"
                    dense
                  >
                  </v-checkbox>
                </v-row>
              </v-col>

              <v-col cols="3">
                <span class="ml-1 mb-2">발급 기관</span
                ><span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  v-model="organization"
                  placeholder="발급 기관"
                  solo
                  dense
                  required
                  :rules="[(v) => !!v]"
                  maxLength="32"
                  hide-details
                  color="navy"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="mt-3 mb-3"></v-divider>

            <v-row justify="center">
              <c-btn
                v-if="this.isUpdated"
                class="mr-1 mt-2"
                color="blue"
                outlined
                @click="onUpdateVoucher"
                >수정</c-btn
              >
              <c-btn
                v-else
                class="mr-1 mt-2"
                color="blue"
                outlined
                @click="onAddVoucher"
                >등록</c-btn
              >
              <c-btn
                class="mt-2"
                color="gray"
                outlined
                @click="openFlag = false"
                >취소</c-btn
              >
            </v-row>
          </v-container>
        </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    voucherFormData: {
      type: Object,
      default: undefined,
    },
  },

  data: () => ({
    openFlag: false,
    isUpdated: false,

    optionList1: [],
    optionList2: [],
    selectAllcustomerType: false,
    selectAllcustomerReg: false,

    //VoucherInfo
    voucherName: "",
    organization: "",
    registerType: "",
    voucherType: "개수 차감",
    general: false,
    infants: false,
    mother: false,

    customerTypeList: [
      { label: "임산부", value: "임산부" },
      { label: "영유아", value: "영유아" },
      { label: "일반", value: "일반" },
    ],
    customerRegList: [
      { label: "온라인 회원", value: "on" },
      { label: "오프라인 회원", value: "off" },
    ],
  }),
  watch: {
    open(value) {
      this.initData();
      if (value && this.voucherFormData) {
        if (this.voucherFormData.id) {
          this.isUpdated = true;
        }

        if (this.voucherFormData.general) this.optionList1.push("일반");
        if (this.voucherFormData.infants) this.optionList1.push("영유아");
        if (this.voucherFormData.mother) this.optionList1.push("임산부");

        if (this.voucherFormData.registerType.indexOf("on") !== -1)
          this.optionList2.push("on");
        if (this.voucherFormData.registerType.indexOf("off") !== -1)
          this.optionList2.push("off");

        //VoucherInfo
        this.voucherName = this.voucherFormData.name;
        this.organization = this.voucherFormData.organization;
        this.voucherType = this.voucherFormData.type;
      }

      this.openFlag = value;
    },
    openFlag(value) {
      this.$emit("update:open", value);
    },
    optionList1(newVal) {
      if (
        newVal &&
        this.customerTypeList &&
        newVal.length !== this.customerTypeList.length
      ) {
        this.selectAllcustomerType = false;
      }

      if (this.optionList1.indexOf("일반") !== -1) this.general = true;
      else this.general = false;
      if (this.optionList1.indexOf("영유아") !== -1) this.infants = true;
      else this.infants = false;
      if (this.optionList1.indexOf("임산부") !== -1) this.mother = true;
      else this.mother = false;
    },
    optionList2(newVal) {
      if (
        newVal &&
        this.customerRegList &&
        newVal.length !== this.customerRegList.length
      ) {
        this.selectAllcustomerReg = false;
      }

      this.registerType = this.optionList2.toString();
    },
  },
  methods: {
    initData() {
      this.optionList1 = [];
      this.optionList2 = [];
      this.selectAllcustomerType = false;
      this.selectAllcustomerReg = false;

      //VoucherInfo
      this.voucherName = "";
      this.organization = "";
      this.registerType = "";
      this.voucherType = "개수 차감";
      this.general = false;
      this.infants = false;
      this.mother = false;
    },
    onSelectAllcustomerType(flag) {
      if (flag)
        this.optionList1 = this.customerTypeList.map((item) => item.value);
      else this.optionList1 = [];
    },
    onSelectAllcustomerReg(flag) {
      if (flag)
        this.optionList2 = this.customerRegList.map((item) => item.value);
      else this.optionList2 = [];
    },
    onAddVoucher() {
      if (
        !this.$refs.form.validate() ||
        !this.optionList1 ||
        this.optionList1.length < 1 ||
        !this.optionList2 ||
        this.optionList2.length < 1
      ) {
        this.$store.commit("snackbar", {
          timeout: 2000,
          msg: "비어있는 필드가 있습니다.",
        });
        return;
      }

      let reqData = {
        name: this.voucherName,
        organization: this.organization,
        regitType: this.registerType,
        voucherType: this.voucherType,

        general: this.general,
        infants: this.infants,
        mother: this.mother,
      };

      this.$emit("reqAddVoucher", reqData);
    },
    onUpdateVoucher() {
      if (
        !this.$refs.form.validate() ||
        !this.optionList1 ||
        this.optionList1.length < 1 ||
        !this.optionList2 ||
        this.optionList2.length < 1
      ) {
        this.$store.commit("snackbar", {
          timeout: 2000,
          msg: "비어있는 필드가 있습니다.",
        });
        return;
      }

      let reqData = {
        id: this.voucherFormData.id,
        name: this.voucherName,
        organization: this.organization,
        regitType: this.registerType,
        voucherType: this.voucherType,

        general: this.general,
        infants: this.infants,
        mother: this.mother,
      };

      this.$emit("reqUpdateVoucher", reqData);
    },
  },
};
</script>
